<button
  type="button"
  #cardButton
  (click)="cardClicked.emit()"
  class="card text-decoration-none border-radius-3 position-relative bg-white"
>
  <div class="card-body align-content-center text-center w-full p-0">
    @if (cardIcon) {
      <i [ngClass]="cardIcon" class="fs-2"></i>
    }

    <div class="fw-medium">
      {{ cardLabel }}
    </div>
  </div>
</button>
